import { ALL_APPLICATIONS_ROUTES_CONFIG } from "../../config/config"

export function updateBrowserTitle() {
  const currentRoute = window.location.pathname
  const currentRouteConfig = ALL_APPLICATIONS_ROUTES_CONFIG.find(
    route=> route.route === currentRoute,
  )
  if (currentRouteConfig) {
    document.title = currentRouteConfig.browserTitle
  } else {
    document.title = "Language Learning App"
  }

  return currentRoute
}
